import styled from 'styled-components'
import { CARD_STYLED_PROPS } from './interface'

export const Title = styled.h2`
  font-size: 12px;
  text-transform: capitalize;
`
export const CardRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
export const Combination = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 20px 0;
  span {
    font-size: 12px;
  }
`
export const Card = styled.div<CARD_STYLED_PROPS>`
  background: ${({ background, isWin }) => (isWin ? '#ffb000' : background)};
  border-radius: 6px;
  height: 50px;
  width: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 2px;
  p {
    font-size: 14px;
    font-family: 'GT America, boldN';
    color: ${({ colors }) => colors};
    line-height: 1;
  }
  svg {
    width: 14px;
    height: 14px;
    path {
      fill: ${({ colors }) => colors};
    }
  }
`

export const CustomButton = styled.div<{ raise?: boolean }>`
  display: flex;
  .bet-button {
    flex-shrink: 0;
    margin-right: 10px;
    svg {
      transform: ${({ raise }) => raise && 'rotateX(0deg)'};
    }
  }
  span {
    font-size: 12px;
    font-family: 'GT America, boldN';
  }
`
